// Data da inspeção: wire em ISO `YYYY-MM-DD`; exibição no idioma da sessão
// (form §7.2 / i18n.mdc). Exemplo em PT-BR: `15/07/2026`.

import { formatDate, formatDateTime } from "@shared/utils";

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})/;

/** ISO civil → data no idioma da sessão (`language` de `useLocalization`). */
export const formatInspectionDate = (
  isoDate?: string | null,
  locale?: string | null,
): string => formatDate(isoDate, locale);

/** Timestamp ISO → data/hora no idioma da sessão (24h, sem segundos). */
export const formatInspectionDateTime = (
  isoDate?: string | null,
  locale?: string | null,
): string => formatDateTime(isoDate, locale);

/** Máscara progressiva `DD/MM/YYYY` aplicada a cada tecla digitada. */
export const maskInspectionDate = (raw: string): string => {
  const digits = raw.replace(/\D/g, "").slice(0, 8);

  if (digits.length < 2) return digits;

  let masked = `${digits.slice(0, 2)}/${digits.slice(2, 4)}`;
  if (digits.length >= 4) masked += `/${digits.slice(4, 8)}`;

  return masked;
};

/** Data local de hoje em `YYYY-MM-DD` (input `type="date"`). */
export const todayInspectionIsoDate = (): string => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

/** Timestamp/ISO → valor de `<input type="date">` (`YYYY-MM-DD`). */
export const toInspectionDateInputValue = (isoDate?: string | null): string => {
  if (!isoDate) return "";
  const match = isoDate.match(ISO_DATE);
  return match ? `${match[1]}-${match[2]}-${match[3]}` : "";
};

/** `15/07/2026` → `2026-07-15`; `null` quando incompleta/inválida. */
export const parseInspectionDate = (displayDate: string): string | null => {
  const digits = displayDate.replace(/\D/g, "");
  if (digits.length !== 8) return null;

  const day = digits.slice(0, 2);
  const month = digits.slice(2, 4);
  const year = digits.slice(4, 8);

  const parsed = new Date(`${year}-${month}-${day}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) return null;

  return `${year}-${month}-${day}`;
};
